var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4385(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#F2411F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1781 14.8781C25.9812 14.1375 25.4031 13.5563 24.6687 13.3594C23.3375 13 18 13 18 13C18 13 12.6625 13 11.3312 13.3594C10.5968 13.5563 10.0187 14.1375 9.82183 14.8781C9.46558 16.2188 9.46558 19.0125 9.46558 19.0125C9.46558 19.0125 9.46558 21.8063 9.82183 23.1469C10.0187 23.8875 10.5968 24.4437 11.3312 24.6406C12.6625 25 18 25 18 25C18 25 23.3375 25 24.6687 24.6406C25.4031 24.4437 25.9812 23.8844 26.1781 23.1469C26.5343 21.8063 26.5343 19.0125 26.5343 19.0125C26.5343 19.0125 26.5343 16.2188 26.1781 14.8781ZM16.2562 21.55V16.475L20.7156 19.0125L16.2562 21.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4385);
export default __webpack_public_path__ + "static/media/Group 4385.4017e56d138b81695233783822b7716f.svg";
export { ForwardRef as ReactComponent };